import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { InputSwitchDemoSection } from "@/features/developer/components/InputSwitchDemoSection";
import { INPUT_SWITCH_DEMOS } from "@/features/developer/fixtures/uiDemos";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/components/input-switch")({
    component: InputSwitchDemoPage,
});

function InputSwitchDemoPage() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Input switch", route: { to: "/design/components/input-switch" } },
    ]);

    return (
        <AdminPageLayout
            title="Input switch"
            description="Every input_key handled by InputSwitch. Some inputs that fetch diary data (repeatable group, ratings list, photo) may appear empty outside a live diary context."
            maxWidthClassName="max-w-4xl"
        >
            <div className="gap-6 grid grid-cols-1">
                {INPUT_SWITCH_DEMOS.map(({ inputKey, input }) => (
                    <InputSwitchDemoSection key={inputKey} inputKey={inputKey} input={input} />
                ))}
            </div>
        </AdminPageLayout>
    );
}
